import { render, staticRenderFns } from "./ImageWithBullets.vue?vue&type=template&id=5b2868e6&scoped=true&"
import script from "./ImageWithBullets.vue?vue&type=script&lang=js&"
export * from "./ImageWithBullets.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithBullets.vue?vue&type=style&index=0&id=5b2868e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2868e6",
  null
  
)

export default component.exports